<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 10%">
                            <CCol sm="12" style="width: 50%;background-size: cover; margin: auto;" class="d-sm-down-none">
                                <CCard class="border-radius-16px p-4 mb-5">
                                    <div class="text-center">
                                        <h3 class="custom-32px-500 text-center font-color-171717">Hey There, Welcome Back! </h3>
                                        <p class="custom-16px-400">Already have an account? Log in to access your profile, preferences, and saved progress.</p>
                                    </div>
    
    
                                    <div :active="$route.query.type === 'individual' || $route.query.type === 'company'">
    
                                        <br />
                                        <div v-if="selectedUser==='individual'">
    
    
                                            <strong class="text-left mt-4 mb-2"> Name</strong>
                                            <input v-model="name" type="text" class="custom-input-app mb-2" />
                                            <br />
                                            <strong class="text-left mt-4 mb-2"> Email</strong>
                                            <input v-model="email" type="text" class="custom-input-app mb-2" />
                                            <br />
                                            <strong class="text-left mt-4 mb-2">Password</strong>
                                            <input v-model="password" type="password" class="custom-input-app mb-4" @input="password_check" />
                                            <br />
                                        </div>
                                        <div v-else>
                                            <strong class="text-left mt-4 mb-2">Company Name</strong>
                                            <input v-model="name" type="text" class="custom-input-app mb-2" />
                                            <br />
                                            <strong class="text-left mt-4 mb-2">Company Email(PIC)</strong>
                                            <input v-model="email" type="text" class="custom-input-app mb-2" @blur="validateEmail" />
                                            <p v-if="emailError" class="text-danger mt-1">{{ emailError }}</p>
                                            <br />
                                            <strong class="text-left mt-4 mb-2">Company Password(PIC)</strong>
                                            <input v-model="password" type="password" class="custom-input-app mb-4" @input="password_check" />
                                            <br />
                                            <strong class="text-left mt-2 mb-2">Company Website</strong>
                                            <input v-model="website" type="text" class="custom-input-app mb-4" />
                                            <br />
                                            <strong class="text-left mt-4 mb-2">Company Detail</strong>
                                            <CTextarea v-model="detail" type="text" class="mb-4" horizontal rows="9" />
                                            <br />
                                        </div>
    
                                        <p class="frmValidation" :class="{'frmValidation--passed' : password.length > 7}">
                                            <img v-if="password.length > 7" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" alt="Unchecked" class="frmIcon" style="width:20px" /> A minimum of 8 character
    
                                        </p>
                                        <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }">
                                            <img v-if="has_uppercase" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one uppercase character
                                        </p>
    
                                        <p class="frmValidation" :class="{'frmValidation--passed' : has_lowercase }">
                                            <img v-if="has_lowercase" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one lowercase character
                                        </p>
                                        <p class="frmValidation" :class="{'frmValidation--passed' : has_number }">
                                            <img v-if="has_number" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one numeric character
                                        </p>
                                        <p class="frmValidation" :class="{'frmValidation--passed' : has_special }">
                                            <img v-if="has_special" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one symbol character
                                        </p>
    
                                        <CAlert show color="danger" v-if="Error ===true">{{ Message }}</CAlert>
    
    
                                        <div class="text-center mt-2 mb-2">
                                            <span class="custom-border-purple p-2 text-center text-white pr-2 pl-2" v-if="password.length > 7 && has_uppercase && has_lowercase && has_number && has_special" @click="registerAccount()">{{ lblProgress }}</span>
                                            <span class="custom-border-grey p-2 text-center text-white pr-2 pl-2" disabled v-else>Continue</span>
                                        </div>
    
    
                                        <img src="../assets/img/signupwith.png" style="max-width:100%" class="mb-4 mt-4">
    
                                        <div class="custom-border-line mt-2 mb-2">
                                            <div class="inline-container" v-on:click="login">
                                                <img src="../assets/img/google-symbol1.png" class="ml-2" alt="Search Button" style="max-width:20px" />
                                                <span class="text-center" style="margin-left:35%">{{ lblGoogle }}</span>
    
                                            </div>
                                        </div>
                                        <br /><br />
                                        <div style="clear:both"></div>
                                    </div>
    
    
    
    
                                </CCard>
                            </CCol>
    
                            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;" class="d-md-none p-0">
                                <CCard class="border-radius-16px p-4 mb-5">
                                    <div class="text-center">
                                        <h3 class="custom-32px-500 text-center font-color-171717">Hey There, Welcome Back! </h3>
                                        <p class="custom-16px-400">Already have an account? Log in to access your profile, preferences, and saved progress.</p>
                                    </div>
    
                                    <div :active="$route.query.type === 'individual' || $route.query.type === 'company'">
    
                                        <br />
                                        <div v-if="selectedUser==='individual'">
    
    
                                            <strong class="text-left mt-4 mb-2"> Name</strong>
                                            <input v-model="name" type="text" class="custom-input-app mb-2" />
                                            <br />
                                            <strong class="text-left mt-4 mb-2"> Email</strong>
                                            <input v-model="email" type="text" class="custom-input-app mb-2" />
                                            <br />
                                            <strong class="text-left mt-4 mb-2">Password</strong>
                                            <input v-model="password" type="password" class="custom-input-app mb-4" @input="password_check" />
                                            <br />
                                        </div>
                                        <div v-else>
                                            <strong class="text-left mt-4 mb-2">Company Name</strong>
                                            <input v-model="name" type="text" class="custom-input-app mb-2" />
                                            <br />
                                            <strong class="text-left mt-4 mb-2">Company Email(PIC)</strong>
                                            <input v-model="email" type="text" class="custom-input-app mb-2" @blur="validateEmail" />
                                            <p v-if="emailError" class="text-danger mt-1">{{ emailError }}</p>
                                            <br />
                                            <strong class="text-left mt-4 mb-2">Company Password(PIC)</strong>
                                            <input v-model="password" type="password" class="custom-input-app mb-4" @input="password_check" />
                                            <br />
                                            <strong class="text-left mt-2 mb-2">Company Website</strong>
                                            <input v-model="website" type="text" class="custom-input-app mb-4" />
                                            <br />
                                            <strong class="text-left mt-4 mb-2">Company Detail</strong>
                                            <CTextarea v-model="detail" type="text" class="mb-4" horizontal rows="9" />
                                            <br />
                                        </div>
    
                                        <p class="frmValidation" :class="{'frmValidation--passed' : password.length > 7}">
                                            <img v-if="password.length > 7" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" alt="Unchecked" class="frmIcon" style="width:20px" /> A minimum of 8 character
    
                                        </p>
                                        <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }">
                                            <img v-if="has_uppercase" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one uppercase character
                                        </p>
    
                                        <p class="frmValidation" :class="{'frmValidation--passed' : has_lowercase }">
                                            <img v-if="has_lowercase" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one lowercase character
                                        </p>
                                        <p class="frmValidation" :class="{'frmValidation--passed' : has_number }">
                                            <img v-if="has_number" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one numeric character
                                        </p>
                                        <p class="frmValidation" :class="{'frmValidation--passed' : has_special }">
                                            <img v-if="has_special" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one symbol character
                                        </p>
    
                                        <div class="text-center mt-2 mb-2">
                                            <CAlert show color="danger" v-if="MessageError === true">
                                                <strong class="text-danger mr-2">Error !</strong> Error to save the data
                                            </CAlert>

                                            <CAlert show color="danger" v-if="Error ===true">{{ Message }}</CAlert>

    
                                            <span class="custom-border-purple p-2 text-center text-white pr-2 pl-2" v-if="password.length > 7 && has_uppercase && has_lowercase && has_number && has_special" @click="registerAccount()">{{ lblProgress }}</span>
                                            <span class="custom-border-grey p-2 text-center text-white pr-2 pl-2" disabled v-else>Continue</span>
                                        </div>
    
                                        <img src="../assets/img/signupwith.png" style="max-width:100%" class="mb-4 mt-4">
    
                                        <div class="custom-border-line mt-2 mb-2">
                                            <div class="inline-container" v-on:click="login">
                                                <img src="../assets/img/google-symbol1.png" class="ml-2" alt="Search Button" style="max-width:20px" />
                                                <span class="text-center" style="margin-left:35%">{{ lblGoogle }}</span>
    
                                            </div>
                                        </div>
                                        <br /><br />
                                        <div style="clear:both"></div>
                                    </div>
    
    
    
    
                                </CCard>
                            </CCol>
                        </div>
                    </CCol>
                </CRow>
            </CCol>
        </CCol>
    
        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/success.png" />
                    <h3 class="custom-32px-500">Success!</h3>
                    <h3 class="custom-18px text-center">Your account is succesfully registered.</h3>
                </div>
                <CButton class="button-border-202020" @click="closePopup" block><span class="ml-2 mr-2">Close</span></CButton>
            </div>
        </div>
    
    </div>
</template>


<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/all/banner.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

            name: "",
            email: this.$route.query.email,
            phone: "",
            password: "",
            selectedUser: this.$route.query.type === 'individual' ? 'individual' : 'company',
            website: "",
            detail: "",
            has_number: false,
            has_lowercase: false,
            has_uppercase: false,
            has_special: false,

            userOptions: [{

                id: 1,
                UserType: "Candidate",


            }, ],
            isLanguagePopupVisible1: false,

            userEmail: "",
            userPassword: "",

            ErrorLogin: false,
            Message: "",

            response: "",
            lblGoogle: "Google",
            lblProgress: "Continue",
            MessageError: false,
            Error: "",

            emailError: "",
            disallowedDomains: ['yahoo.com', 'gmail.com', 'hotmail.com'],




        };
    },
    created() {
        AOS.init();
        // Check if the 'type' query parameter is present in the URL
        const type = this.$route.query.type;
        if (type === 'individual') {
            // If the type is 'individual', set the selectedUser to 'individual'
            this.selectedUser = 'individual';
        } else if (type === 'company') {
            // If the type is 'company', set the selectedUser to 'company'
            this.selectedUser = 'company';
        } else {
            // Handle other cases, if necessary
        }
    },


    methods: {
        updateSelection(selection) {
            this.selectedUser = selection;
        },
        password_check() {
            this.has_number = /\d/.test(this.password);
            this.has_lowercase = /[a-z]/.test(this.password);
            this.has_uppercase = /[A-Z]/.test(this.password);
            this.has_special = /[!@#$%^&*(),.?":{}|<>]/.test(this.password);

            // Debugging logs
            console.log('Password:', this.password);
            console.log('Has number:', this.has_number);
            console.log('Has lowercase:', this.has_lowercase);
            console.log('Has uppercase:', this.has_uppercase);
            console.log('Has special:', this.has_special);
        },
        registerAccount() {
            this.Error = false;
            this.lblProgress = "Processing";

            const formData = new FormData();

            if (this.emailError) {
                this.lblProgress = "Continue";
                this.Error = true;
                this.Message = "Error:Please update your email.Email must be company email";
            return;
            }

            if (this.Name === "" || this.Email === "" || this.Password === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.$route.query.phone);
                formData.append("userType", this.$route.query.type);
                formData.append("password", this.password);
                formData.append("website", this.website);
                formData.append("detail", this.detail);
                formData.append("countryId", this.$route.query.countryid);

                this.$API
                    .post(this.$Register, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;

                        }
                        if (response.status == 200) {

                            if (response.data.status !== 400) {

                                if (
                                    this.$route.query.targetUrl != "" &&
                                    (this.$route.query.targetUrl != null) &
                                    (this.$route.query.targetUrl != undefined)
                                ) {
                                    this.$router.push(this.$route.query.targetUrl);
                                } else {
                                    this.isLanguagePopupVisible1 = true;
                                    // this.$router.push("Login");
                                }


                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                                this.MessageError = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                            this.MessageError = true;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                        this.MessageError = true;
                    });
            }
        },
        GoToHomeUser() {
            this.$router.push("/Profile");
        },
        async login() {
            try {
                var googleuser = await this.$gAuth.signIn(); // Wait for signIn() method to complete
                this.isLogin = this.$gAuth.isAuthorized; // Update isLogin status after successful signIn
                console.log('Is user logged in?', this.isLogin);
                var idToken = googleuser.getAuthResponse().id_token;
                console.log("getProfile" + googleuser.getBasicProfile());
                console.log("auth" + googleuser.getAuthResponse());
                console.log("auth" + this.$gAuth.GoogleAuth.currentUser.get().getAuthResponse());
                // If the user is logged in, retrieve the user profile to access the email
                if (this.isLogin) {
                    console.log('ID Token:', idToken);

                    const type = this.$route.query.type;
                    const countryid = this.$route.query.countryid;
                    const phone = this.$route.query.phone;


                    this.getUserEmail(idToken, type, countryid, phone);
                }
            } catch (error) {
                console.error('Error during login:', error);
            }
        },
        async getUserEmail(idToken, type, countryid, phone) {
            try {
                const response = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
                if (response.status === 200) {
                    this.user = response.data;
                    localStorage.setItem('idToken', idToken);
                    this.SetSession(idToken, this.user, type, countryid, phone);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async SetSession(idToken, email, type, countryid, phone) {
            try {
                const response = await this.$API.get(this.$InsertSession + "?idToken=" + idToken);
                if (response.status === 202) {
                    this.registerAccountGoogle(idToken, email, type, countryid, phone);

                } else if (response.status === 200) {
                    if (response.data.userType === 'company') {
                        this.$router.push("Dashboard");
                    } else {
                        this.$router.push("Profile");
                    }

                    console.error("Failed to fetch user information:", response);
                } else {
                    this.emailuser = response.message;
                    console.log("tets" + this.emailuser);
                    this.isLanguagePopupVisible1 = true;
                    this.registerAccountGoogle(this.emailuser, type, countryid, phone);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        registerAccountGoogle(idToken, email, type, countryid, phone) {

            const formData = new FormData();
            this.buttonLabel = 'Processing';
            formData.append("name", email);
            formData.append("email", email);
            formData.append("phone", phone);
            formData.append("userType", type);
            formData.append("password", "");
            formData.append("website", this.website);
            formData.append("detail", this.detail);
            formData.append("countryId", countryid);


            this.$API
                .post(this.$Register, formData, { withCredentials: true })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {

                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {

                                this.getUserEmailLogin(idToken)


                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        async getUserEmailLogin(idToken) {
            this.lblGoogle = "Processing..";
            try {
                const response = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
                if (response.status === 200) {
                    this.user = response.data;
                    this.SetSessionLogin(idToken, this.user);

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        async SetSessionLogin(idToken, email) {
            this.lblGoogle = "Processing..";
            try {
                const response = await this.$API.get(this.$InsertSession + "?idToken=" + idToken);
                console.log("Response:", response); // Log the entire response object to see its structure
                if (response.status === 202) {
                    // Handle status 202
                } else if (response.status === 200) {
                    const userData = response.data; // Extract user data
                    console.log("User Data:", userData); // Log the user data object to see its structure

                    // Extract userType directly from userData
                    const userType = userData.userType;
                    console.log("User Type:", userType); // Log the user type

                    // Handle non-200 status code
                    if (response.data.data.userType === 'individual') {
                        this.$router.push("Profile");
                    } else if (response.data.data.userType === '-') {

                        this.$router.push("Profile");

                    } else {

                        this.$router.push("Dashboard");

                    }
                    console.error("Failed to fetch user information:", response);
                } else {
                    // Handle other status codes
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        closePopup() {
            this.isLanguagePopupVisible1 = false;
            this.$router.push("Login");
        },
        validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email format validation

      // Check if the email is valid
      if (!emailRegex.test(this.email)) {
        this.emailError = 'Please enter a valid email address.';
        return;
      }

      // Extract the domain from the email address
      const domain = this.email.split('@')[1];

      // Check if the domain is in the disallowed list
      if (this.disallowedDomains.includes(domain)) {
        this.emailError = 'Email cannot be from Yahoo, Gmail, or Hotmail.';
        return;
      }

      // If domain is not in the disallowed list, assume it's a company email
      if (domain.includes('.')) {  // Ensures the domain is a valid "company" domain
        this.emailError = null; // Validation passes
      } else {
        this.emailError = 'Please enter a valid company email address.';
      }
    },
    },



};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>